exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.all-the-width[data-v-7ffd8970] {\n  width: 100%;\n}\n\n", ""]);

// exports
